export * from './delete-icon'

